import {
    Component,
    OnInit,
    ViewEncapsulation,
    Input
} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BaseComponent} from "../../../../common/components/base.component";
import {HubApiService} from 'services/hub.api.service';
import {ActivatedRoute} from '@angular/router';
import {AssignTourModalActions, AssignTourModalData} from "../../assign.tour.modal/assign.tour.modal.provider";
import {ButtonTriggerEvent} from "../../../../common/components";
import {AssignTourModalComponent} from "../../assign.tour.modal/assign.tour.modal.component";
import {EditCityModalActions} from "../../edit.city.modal/edit.city.modal.provider";
import {EditCityModalComponent} from "../../edit.city.modal/edit.city.modal.component";
import {HubFeed} from "../../../../models/hub/hub.feed";
import {HubComponent} from "../../hub.component";
import {AlertifyService} from "../../../../services/alertify.service";
import {ModalService} from "../../../../common/services/modal.service";
import {AddCityModalActions, AddCityModalData} from "../../add.city.modal/add.city.modal.provider";
import {AddCityModalComponent} from "../../add.city.modal/add.city.modal.component";
import {
    ConfirmModalActions,
    ConfirmModalData
} from "../../../../common/components/confirm.modal/confirm.modal.provider";
import {ConfirmModalComponent} from "../../../../common/components/confirm.modal/confirm.modal.component";
import {HubFacebookFeedsCommand} from "../../../../commands/hub/event/add.facebook.general.feed.command";
import {HubFacebookLocationFeedsStore, ToggleAndDataSourceStore} from "../../../../stores/hub.calendar.store";
import {Observable} from "rxjs/Observable";
import {isNullOrUndefined} from "util";
import {VisitorApiService} from "../../../../services/visitor.api.service";
import {HubVisitorToggleDataSource} from "../../../../models/hub/hub.visitor.feature.toggle";

@Component({
    selector: 'ig-region-management',
    templateUrl: './region.component.html',
    styleUrls: ['./region.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class RegionComponent extends BaseComponent implements OnInit {
    @Input() public type: 'tour' | 'trip';

    public hubName = null;
    public isCreatingRegion = false;
    public isEditRegion = [];
    public isLoadingFeeds = false;
    public hubLocations: HubFeed[];
    public form: FormGroup;
    public featuresToggle = {
        tripPlanner: false,
        multipleCities: false,
    };
    public multiCities = {
        active: false,
        cityBlock: {
            active: true
        },
        regions: [
            // {
            //     name: 'Northwest',
            //     cities: []
            // }, {
            //     name: 'Southeast',
            //     cities: []
            // }
        ],
        tours: []
    };
    public placeSource = 'google';


    constructor(private hubApiService: HubApiService,
                private formBuilder: FormBuilder,
                private parent: HubComponent,
                private alertify: AlertifyService,
                private modalService: ModalService,
                private visitorApiService: VisitorApiService,
                private hubFacebookLocationFeedsStore: HubFacebookLocationFeedsStore,
                private activatedRoute: ActivatedRoute,
    ) {
        super({activatedRoute});

    }


    public ngOnInit() {
        let {hubName} = this.allRouteParams;
        this.hubName = hubName;
        this.parent.location = 'Trip Planner';

        this.form = this.formBuilder.group({
            regionName: [null, []],
        });

        this.hubFacebookLocationFeedsStore.locationCommand
            .takeUntil(this.isDestroyed)
            .subscribe((hubLocations: HubFacebookFeedsCommand) => {
                this.hubLocations = hubLocations.hubPages;
                this.hubLocations = (this.hubLocations && this.hubLocations.length) ? this.hubLocations.filter(x => x.socialName === this.placeSource) : [];
                this.setHubLocations();
            });

        if (!this.hubLocations || !this.hubLocations.length) {
            this.getHubLocations();
        }

        this.visitorApiService.getToggles(this.hubName).subscribe(toggle => {
            if (toggle) {
                this.featuresToggle.tripPlanner = isNullOrUndefined(toggle.tripPlanner) ? true : toggle.tripPlanner;
                this.featuresToggle.multipleCities = !!toggle.multipleCities;
                this.multiCities.active = this.featuresToggle.multipleCities;
                if (this.multiCities.active) {
                    this.hubApiService.getCityBlockToggle(this.hubName).subscribe(block => {
                        this.multiCities.cityBlock.active = !isNullOrUndefined(block.active) ? block.active : true;
                    });
                }
            }
        });
        this.visitorApiService.getDataSource(this.hubName).subscribe(dataSource => {
            if (dataSource) {
                this.placeSource = dataSource.place;
            }
        });

        this.getRegions();
        this.getTours();
    }

    public toggleMultipleCities() {
        this.hubApiService.toggleMultipleCities(this.hubName, this.multiCities.active).subscribe(() => {
            this.alertify.successfully(`Turn the regions feature ${this.multiCities.active ? 'on' : 'off'}`);
        });
    }

    public toggleCityBlock() {
        this.hubApiService.toggleCityBlock(this.hubName, this.multiCities.cityBlock.active).subscribe(() => {
            this.alertify.successfully(`Turn the city block ${this.multiCities.cityBlock.active ? 'on' : 'off'}`);
        });
    }

    public editRegion(region, index) {
        this.isEditRegion[index] = true;
    }

    public updateRegionName($event, region, index) {
        this.hubApiService.updateRegionName(this.hubName, {id: region.id, name: region.name})
            .finally($event.complete)
            .subscribe(data => {
                this.isEditRegion[index] = false;
                this.alertify.successfully('Update the region name');
            });
    }

    public deleteRegion(region) {
        let actions = <ConfirmModalActions>{
            confirm: (event: ButtonTriggerEvent) => {
                this.hubApiService.deleteRegion(this.hubName, region.id)
                    .finally(event.complete).subscribe(data => {
                    let newRegions = [];
                    this.multiCities.regions.forEach(x => {
                        if (x.id !== region.id) {
                            newRegions.push(x);
                        }
                    });
                    this.multiCities.regions = newRegions;
                    this.alertify.successfully('Delete the region');
                });
            }
        };

        let data = <ConfirmModalData>{
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: `Are you sure you want to remove delete this region?`,
            confirmModalConfirmButtonText: 'Delete',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true
        };

        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                {provide: ConfirmModalActions, useValue: actions},
                {provide: ConfirmModalData, useValue: data}
            ]
        });
    }

    public removeCityFromRegion(region, city) {
        let actions = <ConfirmModalActions>{
            confirm: (event: ButtonTriggerEvent) => {
                this.hubApiService.removeCityFromRegion(this.hubName, region.id, city.id)
                    .finally(event.complete).subscribe(data => {
                    //let index = region.cities.getElementIndex(x => x.id === city.id);
                    //region.cities = region.cities.splice(index, 1);
                    let newCities = [];
                    region.cities.forEach(x => {
                        if (x.id !== city.id) {
                            newCities.push(x);
                        }
                    });
                    region.cities = newCities;
                });
            }
        };

        let data = <ConfirmModalData>{
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: `Are you sure you want to remove "${city.cityTitle || city.title}" from this region?`,
            confirmModalConfirmButtonText: 'Remove',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true
        };

        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                {provide: ConfirmModalActions, useValue: actions},
                {provide: ConfirmModalData, useValue: data}
            ]
        });
    }

    public loadCities(region?) {
        if (region) {
            let cities = [];
            region.cities.forEach(city => {
                let c = this.hubLocations.filter(x => x.socialName === this.placeSource).first(x => x.id === city.id);
                if (c) {
                    city.cityTitle = c.cityTitle;
                    city.title = c.title;
                    cities.push(city);
                }
            });
            region.cities = cities;
        } else {
            this.multiCities.regions.forEach(region => {
                let cities = [];
                region.cities.forEach(city => {
                    let c = this.hubLocations.first(x => x.id === city.id);
                    if (c) {
                        city.cityTitle = c.cityTitle;
                        city.title = c.title;
                        cities.push(city);
                    }
                });
                region.cities = cities;
            });
        }
    }

    public addCity(region: any) {
        let actions = <AddCityModalActions>{
            confirm: (event: ButtonTriggerEvent, addedCityIds: any) => {
                let obj = [];
                addedCityIds.forEach(x => {
                    obj.push({id: x});
                });
                region.cities.push(...obj);
                this.loadCities(region);
                this.alertify.successfully('Add the cities');
            }
        };

        let locationFeeds = [];
        this.hubLocations.forEach(x => {
            let isInRegion = false;
            region.cities.forEach(y => {
                if (y.id === x.id) {
                    isInRegion = true;
                }
            });
            if (!isInRegion) {
                locationFeeds.push({locationFeed: x, isInRegion: isInRegion});
            }
        });

        this.modalService.show({
            component: AddCityModalComponent,
            providers: [
                {provide: AddCityModalActions, useValue: actions},
                {
                    provide: AddCityModalData,
                    useValue: new AddCityModalData(this.hubName, region.id, this.hubLocations.length === 0, locationFeeds)
                }
            ]
        });
    }

    public enterAssignTour(tour) {
        let actions = <AssignTourModalActions>{
            confirm: (event: ButtonTriggerEvent, data: any) => {
                this.getRegions();
                this.alertify.successfully('Assign the itinerary');
            }
        };

        let regions = [];
        this.multiCities.regions.forEach(x => {
            let isInRegion = false;
            x.tours.forEach(y => {
                if (y.id === tour._id) {
                    isInRegion = true;
                }
            });
            regions.push({region: x, isInRegion: isInRegion});
        });

        this.modalService.show({
            component: AssignTourModalComponent,
            providers: [
                {provide: AssignTourModalActions, useValue: actions},
                {
                    provide: AssignTourModalData,
                    useValue: new AssignTourModalData(this.hubName, tour._id, regions)
                },
            ],
        });
    }

    public enterEditCity(feed) {
        let actions = <EditCityModalActions>{
            confirm: (event: ButtonTriggerEvent, data: any) => {
                if (data.image) {
                    feed.cityImage = data.image;
                }
                feed.cityTitle = data.cityTitle;
                this.alertify.successfully('Update the city');

                this.hubApiService.getLocationFeeds(this.hubName).subscribe(data => {
                    this.hubLocations = data.filter(x => x.socialName === this.placeSource);
                    this.setHubLocations();
                    this.loadCities();
                });
            }
        };

        feed.hubName = this.hubName;
        this.modalService.show({
            component: EditCityModalComponent,
            providers: [
                {provide: EditCityModalActions, useValue: actions},
                {provide: HubFeed, useValue: feed},
            ],
        });
    }

    public addNewRegion() {
        this.isCreatingRegion = true;
        let command = {name: 'New Region', cities: [], id: '', tours: []};
        this.hubApiService.createRegion(this.hubName, command).subscribe(regionId => {
            command.id = regionId;
            this.multiCities.regions.push(command);
            this.isCreatingRegion = false;
        });
    }

    private setHubLocations() {
        this.hubLocations && this.hubLocations.forEach(x => {
            x.cityTitle = x.cityTitle || x.title;
        });
    }

    private getRegions() {
        this.hubApiService.getRegions(this.hubName).subscribe(data => {
            this.multiCities.regions = data;
            this.isEditRegion = [];
            this.multiCities.regions.forEach(x => {
                this.isEditRegion.push(false);
            });
        });
    }

    private getTours() {
        this.hubApiService.getTours(this.hubName)
            .subscribe(data => {
                this.multiCities.tours = data;
            });
    }

    private getHubLocations() {
        let times = 0;
        this.isLoadingFeeds = true;
        let getFeeds = () => this.hubApiService.getLocationFeeds(this.hubName)
            .catch(err => {
                if (times < 3) {
                    getFeeds();
                }
                times++;
                return Observable.throw(err.statusText);
            })
            .subscribe(data => {
                this.isLoadingFeeds = false;
                this.hubLocations = data;
                this.hubLocations = (this.hubLocations && this.hubLocations.length) ? this.hubLocations.filter(x => x.socialName === this.placeSource) : [];
                this.setHubLocations();
            });
        getFeeds();
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/tours/regions/region.component.ts